import { Component, inject, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TherapistClientApiService } from '@therapist/shared/services/api/therapist-client-api.service';
import { TherapistClientSearchItemDto } from '@therapist/shared/models/client/therapist-client-search-item.dto';
import { catchError, debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'sana-tp-client-search-field',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AutoComplete,
    DatePipe
  ],
  templateUrl: './client-search-field.component.html',
  styleUrl: './client-search-field.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ClientSearchFieldComponent {

  readonly #router = inject(Router);
  readonly #clientApiService = inject(TherapistClientApiService);

  filteredClients: TherapistClientSearchItemDto[] = [];
  selectedClient: TherapistClientSearchItemDto | null = null;

  #searchTerms = new Subject<string>();

  constructor() {
    this.#searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => this.#clientApiService.searchByName(term)),
      catchError(error => this.filteredClients = [])
    ).subscribe({
      next: clients => this.filteredClients = clients,
      error: () => this.filteredClients = []
    });
  }

  /** Wird bei jeder Tasteneingabe im Autocomplete aufgerufen */
  filterClients(event: AutoCompleteCompleteEvent): void {
    this.#searchTerms.next(event.query);
  }

  /** Wird ausgeführt, wenn der Nutzer einen Eintrag auswählt */
  onSelectClient(event: AutoCompleteSelectEvent): void {
    this.#router.navigate([`/client/${event.value.id}`]);
  }

  /** Route zum Anlegen eines neuen Clients */
  routeToNewClient(): void {
    this.#router.navigate(['/client/add']);
  }

}

